import React from 'react';
import styled from 'styled-components';
import { ButtonText } from 'components/Button';
import { Text } from 'components/Typography';
import { theme, toRem } from 'design';

interface IDetailsAccordionProps {
  title: string;
  buttonText?: string;
  children: React.ReactNode;
}

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  padding: ${toRem(16)};
  background: ${theme.color.white};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  border-radius: ${toRem(8)};
  gap: ${toRem(8)};
`;

const StyledButtonText = styled(ButtonText)`
  width: fit-content;
  font-size: ${toRem(11)};
  font-weight: ${theme.font.weight.medium};
  color: ${theme.color.primary[600]};
  text-decoration: none;
`;

const TextButtonAccordion = ({ title, buttonText = '', children }: IDetailsAccordionProps) => {
  const [contentVisible, setContentVisible] = React.useState(false);

  return (
    <Layout data-cy="text-button-accordion">
      <Text size="small" fontWeight="semibold">
        {title}
      </Text>
      <StyledButtonText label={`${contentVisible ? 'Hide' : 'View'} ${buttonText}`} onClick={() => setContentVisible(!contentVisible)} />
      {contentVisible && children}
    </Layout>
  );
};

export default TextButtonAccordion;
